import { motion } from "framer-motion";

const BANNER =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_82d11e62-96d8-4a58-bd86-23180e6879b5/artifacts/egnglctd_WhatsApp%20Image%202026-08-12%20at%209.45.35%20AM%20%281%29.jpeg";

export const FullBanner = () => (
  <section className="w-full bg-[#F5C842] pt-[92px] md:pt-[104px]" data-testid="full-banner">
    <motion.img
      src={BANNER}
      alt="Heal Seeal — Your Wound, Our Care"
      initial={{ opacity: 0, scale: 1.02 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
      className="w-full h-auto block"
      data-testid="full-banner-image"
    />
  </section>
);
